import { isNumber } from 'lodash';
import React from 'react';
import { NumberInput } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { sectionProps } from 'src/tools/constant';

import {
  moduleHeight,
  moduleHeightUnit,
} from '@/src/tools/contentModulesFieldName';
import { EModuleHeightUnit } from '@/src/types/common/module';
import { OriSelect } from 'src/components/Antd';
import styles from './css.module.less';
const Option = OriSelect.Option;

const ModuleHeight = (props) => {
  const { disabled, title, options } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={title} size='small'>
        <div className={styles.moduleHeightWrap}>
          <div className={styles.moduleHeightInput}>
            <Field
              name={moduleHeight}
              initialValue={100}
              dependencies={[moduleHeightUnit]}>
              {(props, _, { getFieldValue }) => {
                const unit = getFieldValue(moduleHeightUnit);

                return (
                  <NumberInput
                    value={props.value}
                    size={'large'}
                    min={0}
                    max={unit === EModuleHeightUnit.Percentage ? 100 : Infinity}
                    disabled={disabled}
                    onChange={(textBoxWidth) => {
                      if (isNumber(textBoxWidth)) {
                        props.onChange(textBoxWidth);
                      } else {
                        props.onChange(0);
                      }
                    }}
                  />
                );
              }}
            </Field>
          </div>
          <div className={styles.moduleHeightSelector}>
            <Field
              name={moduleHeightUnit}
              initialValue={EModuleHeightUnit.Percentage}>
              <OriSelect disabled={disabled} size='large'>
                {options.map((i) => {
                  const { label, value } = i;
                  return (
                    <Option value={value} key={value}>
                      {label}
                    </Option>
                  );
                })}
              </OriSelect>
            </Field>
          </div>
        </div>
      </ItemWrapper>
    </Section>
  );
};
export default ModuleHeight;
